export class JiraIssue {
  constructor(private readonly url: string) {}

  getUrl() {
    return this.url;
  }
}
